import { CSSProperties, MouseEventHandler } from 'react';
import { Entry } from 'contentful';

export enum ContentSectionType {
  HERO_SECTION = 'heroSection',
  CONTENT_SECTION = 'contentSection',
  INFOBOX_SECTION = 'infoBoxSection',
  HARDCODED_SECTION = 'hardCodedSection',
  PADDING = 'padding',
  HEADER_SECTION = 'headerSection',
  SUBHEADER_SECTION = 'subheaderSection'
}

export enum BlogPostAudienceType {
  STUDENTS = 'Students',
  TUTORS = 'Tutors',
  PARENTS = 'Parents'
}

export enum DisplayTextAlignment {
  RIGHT = 'Right',
  CENTRE = 'Centre',
  LEFT = 'Left'
}

export enum BudgetType {
  NEW_TUTOR,
  INTERMEDIATE_TUTOR,
  EXPERT_TUTOR,
}

export enum TutoringTypes {
  ONLINE = 'ONLINE',
  IN_PERSON = 'IN_PERSON',
}

export enum HardCodedSectionType {
  FIVE_STAR_REVIEWS = '5-Star Reviews',
  TUTOR_HOUSE_IMPROVES_GRADES = 'Tutor House Improves Grades',
  OUR_OTHER_SERVICES = 'Our Other Services',
  TUTOR_CARDS = 'Tutor Cards',
  MET_QUALIFIED_SAFE = 'Met Qualified Safe',
  SEARCH_MESSAGE_DETAILS_LEARN = 'Search Message Details Learn',
  CONNECT_WITH_A_TUTOR_GURU = 'Connect with a Tutor Guru',
  SUBJECTS_WE_OFFER = 'Subjects We Offer',
  TUTORING_FAQS = 'Tutoring FAQs',
  OUR_COMMUNITY_OUR_PLATFORM = 'Our community Our platform',
  EDUCATION_THAT_WORKS_FOR_EVERYONE = 'Education That Works For Everyone',
  TUTORCRUNCHER_TUTOR_SIGNUP_FORM = 'TutorCruncher Tutor Signup Form'
}

export interface LayoutProp {
  children?: any;
  style?: CSSProperties;
  history?: any;
  location?: any;
  match?: any;
  staticContext?: any;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
}

export interface Image {
  file: {
    contentType: string;
    fileName: string;
    url: string;
    details: {
      image: {
        height: number;
        width: number;
      };
      size: number;
    };
  };
  title: string;
}

export interface HeroTutor {
  image: Image;
  name: string;
  tagline: string;
}

export interface InfoBox {
  body: string;
  header: string;
  icon: string;
  iconColour: string;
}

export interface Author {
  firstName: string;
  lastName: string;
  headshot: Entry<Image>;
}

export interface ContentPageLevel {
  id: number;
  level: number;
  title?: string;
  shortcode?: string;
}

export interface ContentPageSubject {
  title: string;
  shortcode: string;
}

export interface ContentPageType {
  title: string;
  slug: string;
  subject: string;
  level: string;
  sections: (
    | Entry<ContentSection>
    | Entry<HardCodedSection>
    | Entry<InfoBoxSection>)[];
}

export interface BlogPostType {
  audience: BlogPostAudienceType;
  author: Entry<Author>;
  featuredImage: Entry<Image>;
  featuredImageAltText: string;
  slug: string;
  snippet: string;
  title: string;
  publishedDate: Date;
  sections: Entry<ContentSection>[];
  featured?: boolean;
}

export interface HomePageType {
  sections: (
    | Entry<ContentSection>
    | Entry<HardCodedSection>
    | Entry<HeroSection>
    | Entry<InfoBoxSection>)[];
}

export interface ContentSection {
  title: string;
  displayTextOnThe: DisplayTextAlignment;
  body?: string;
  image?: Entry<Image>;
  backgroundColour?: string;
  linkUrl?: string;
  linkColour?: string;
  additionalHtml?: string;
  additionalScripts?: string;
}

export interface HardCodedSection {
  sectionType: HardCodedSectionType;
  backgroundColour: string;
}

export interface PaddingSection {
  backgroundColour: string;
  height: number;
}

export interface HeaderSection {
  header: string;
}

export interface SubheaderSection {
  subheader: string;
}

export interface HeroSection {
  title: string;
  subtitle: string;
  buttonText: string;
  heroImage: Entry<Image>;
}

export interface InfoBoxSection {
  title: string;
  description: string;
  icon: string;
  iconColour: string;
  backgroundColour?: string;
  infoBoxBackgroundColour?: string;
}
